
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play",
      function () {
        return require("private-next-pages/play/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/play"])
      });
    }
  